import { Query } from 'node-appwrite';
import awWrapperUtils from './aw-wrapper-utils';
/**
 * A wrapper around the Appwrite TablesDB class that provides a typed interface
 * for the tables in the database.
 *
 * @param T - The type of the client.
 * @param tables - The tables to wrap.
 * @param databaseId - The id of the database.
 *
 * @returns A wrapper around the Appwrite TablesDB class that provides a typed interface
 * for the tables in the database.
 */
export class AppTables {
    tables;
    databaseId;
    _tables;
    constructor(tables, databaseId) {
        this.tables = tables;
        this.databaseId = databaseId;
        this._tables = tables;
    }
    getRow(tableId, rowId, queries = []) {
        return this._tables.getRow({
            databaseId: this.databaseId,
            tableId,
            rowId,
            queries,
        });
    }
    listRows(tableId, queries = []) {
        return this._tables.listRows({
            databaseId: this.databaseId,
            tableId: tableId,
            queries,
        });
    }
    createRow(tableId, rowId, row, permissions, transactionId) {
        return this._tables.createRow({
            databaseId: this.databaseId,
            tableId: tableId,
            rowId: rowId,
            data: awWrapperUtils.patchAppwritePayload(row),
            permissions,
            transactionId,
        });
    }
    updateRow(tableId, rowId, row, permissions, transactionId) {
        return this._tables.updateRow({
            databaseId: this.databaseId,
            tableId: tableId,
            rowId: rowId,
            data: awWrapperUtils.patchAppwritePayload(row),
            permissions,
            transactionId,
        });
    }
    upsertRow(tableId, rowId, row, permissions, transactionId) {
        return this._tables.upsertRow({
            databaseId: this.databaseId,
            tableId: tableId,
            rowId: rowId,
            data: awWrapperUtils.patchAppwritePayload(row),
            permissions,
            transactionId,
        });
    }
    deleteRow(tableId, rowId, transactionId) {
        return this._tables.deleteRow({
            databaseId: this.databaseId,
            tableId: tableId,
            rowId: rowId,
            transactionId,
        });
    }
    async listAllRows(tableId, queries = []) {
        const allRows = [];
        let hasMore = true;
        let offset = 0;
        const limit = 10000; // Maximum allowed by Appwrite (customized by us)
        while (hasMore) {
            const response = await this._tables.listRows({
                databaseId: this.databaseId,
                tableId: tableId,
                queries: [...queries, Query.limit(limit), Query.offset(offset)],
            });
            allRows.push(...response.rows);
            hasMore = response.rows.length === limit;
            offset += limit;
        }
        return allRows;
    }
}
